import React from 'react';

import { Button } from '@components/ui/button';
import { User } from './types';

interface ContactButtonProps {
  user: User;
  onOpenContactModal: () => void;
}

const ContactButton: React.FC<ContactButtonProps> = ({
  user,
  onOpenContactModal,
}) => {
  if (!user?.contactDetails?.enabled) {
    return null;
  }

  const advancedColor = user?.backgroundSettings?.advancedColor;
  const isAdvancedActive = advancedColor?.isActive;

  return (
    <Button
      type="button"
      onClick={onOpenContactModal}
      className="mx-auto mt-0 mb-[30px] w-full max-w-[540px] cursor-pointer"
      style={
        isAdvancedActive
          ? {
              background: advancedColor?.secondary,
              boxShadow: `5px 5px 10px ${advancedColor?.shadow1}, inset 1px 1px 2px ${advancedColor?.shadow3}`,
              color: advancedColor?.text || undefined,
            }
          : undefined
      }
    >
      {user?.contactDetails?.buttonText || 'Contact me'}
    </Button>
  );
};

export default ContactButton;
